import React from 'react'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import { Spinner } from '../Loaders/Loaders'
import { DummyFormBlock } from 'components/Forms/Forms'
import ReactMarkdown from 'components/Markdown/Markdown'
import { useHistory } from 'react-router-dom'
import '../MyRecords/MyRecords.scss'

const MiscellaneousAmendmentModal = ({ show, onDismiss, amendments, loading, recordNum }) => {
  const history = useHistory()
  return (
    <Portal isOpened={show}>
      <Modal
        title="File Amendment"
        closeModal={onDismiss}
        closeButton
        modalSize="small"
      >
        <div className="amendment-launcher">
          {loading && (
            <div className="flex-center" style={{ padding: '24px 0' }}>
              <Spinner className="page-loader" themeColor="medium-neutral" />
            </div>
          )}
          {!loading && (
            <div className="amendments">
              {amendments.length === 0 && (
                <p className="empty">There are no amendments available for this record.</p>
              )}
              {amendments.map((amendment) => (
                <React.Fragment key={amendment.FilingTypeId}>
                  <button
                    className="form-block-card"
                    disabled={amendment.IsDisabled}
                    title={amendment.FormTitle || amendment.FilingTypeName}
                    onClick={() => history.push('/miscellaneous/amend/' + amendment.FormDefinitionId + '/' + recordNum)}
                  >
                    <DummyFormBlock label={amendment.FormTitle || amendment.FilingTypeName} />
                  </button>
                  <ReactMarkdown
                    className="markdown description"
                    source={amendment.Description || ''}
                  />
                  {amendment.WarningMessage && (
                    <ReactMarkdown
                      className={'markdown description ' + (amendment.WarningMessageColor || '')}
                      source={amendment.WarningMessage}
                    />
                  )}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </Modal>
    </Portal>
  )
}

export default MiscellaneousAmendmentModal
